import module from 'module';
import LocalCache from 'shared/util/localCache';

module.factory('accountProductsCache', (http, CacheFactory, config) =>
  new LocalCache({
    provider: () => http.get('/products/accounts/types'),
    cacheFactory: CacheFactory,
    cacheTime: config.cache.accountProducts,
    cacheName: 'accountTypes'
  }));